import { BarChart } from '@mui/x-charts/BarChart'
import { Paper, Typography, CircularProgress, Box } from '@mui/material'
import { useGetRVGSubmissionChartQuery } from 'store/dashboard'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'
import HorizontalBarList from './HorizontalBarList'
import { barChartSlotProps, chartSx } from './chartDefaults'

const RVGSubmissionChart = () => {
  const { startDate, endDate } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetRVGSubmissionChartQuery({
    startDate,
    endDate
  })

  const hasData = (data?.categories ?? []).length > 0

  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      <ChartTitle tooltip='The number of resale value guarantee by submission date'>RVG</ChartTitle>

      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : !hasData ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <>
          <Box sx={{ width: '100%', mb: 3 }}>
            <BarChart
              xAxis={[{ scaleType: 'band', data: data.categories ?? [] }]}
              yAxis={[{ tickMinStep: 1 }]}
              series={(data.series ?? []).map((s) => ({
                label: s.label,
                data: s.data ?? [],
                color: s.color
              }))}
              height={500}
              slotProps={barChartSlotProps}
              sx={chartSx}
            />
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography variant='h6' sx={{ mb: 2 }}>
              Top Car Models
            </Typography>
            {data.topCarModels?.length ? (
              <HorizontalBarList
                data={(() => {
                  const sorted = [...data.topCarModels].sort((a, b) => b.value - a.value)
                  const max = sorted[0]?.value || 1
                  return sorted.map((x) => ({
                    label: x.label,
                    percentage: Math.round((x.value / max) * 100),
                    value: x.value
                  }))
                })()}
                colors={['#4A90D9', '#002C5F']}
              />
            ) : (
              <NoDataAvailable />
            )}
          </Box>
        </>
      )}
    </Paper>
  )
}

export default RVGSubmissionChart
